<template>
  <font-awesome-icon :icon="['fat', 'xmark']" class="color-primaryIcon" :aria-label="$t('general.close')" />
</template>
